
import {mapGetters, mapMutations, mapState} from "vuex";
import HeaderComponent from "@/components/shared/HeaderComponent.vue";
import {defineComponent} from "vue";
import router from "@/router";
import paycoUtils from "@/assets/js/utils";
import Membership from "@/domain/order/Membership";

export default defineComponent ({
  name: "ChargeCardSelection",
  components: {
    HeaderComponent,
  },
  data() {
    return {
      restPrice: 0,
      totalUseAmount: 0,
      chargeCards: [] as Membership[],
    }
  },
  mounted() {
    this.restPrice = this.orderPrice - this.pointUseAmount;
    this.totalUseAmount = this.chargeCardTotalUseAmount;
    this.storeChargeCards.forEach((chargeCard: Membership) => {
      this.chargeCards.push(new Membership(chargeCard));
    });
  },
  computed: {
    ...mapGetters('AppYnStore', [
      'isApp'
    ]),
    ...mapState('MembershipStore',{
      chargeCardTotalUseAmount:'chargeCardTotalUseAmount',
      storeChargeCards:'chargeCards',
      orderPrice:'orderPrice',
      pointUseAmount:'pointUseAmount',
    }),
    commaTotalUseAmount(): string {
      return paycoUtils.numWithCommas(this.totalUseAmount);
    }
  },
  methods: {
    ...mapMutations('MembershipStore', [
      'setChargeCardTotalUseAmount',
      'setSelectedChargeCardList',
      'clearSelectedChargeCardList',
    ]),
    toggleChargeCardSelection(index: number): void {
      if (this.chargeCards[index].selected) {
        this.totalUseAmount -= this.chargeCards[index].usePoint;
        this.chargeCards[index].usePoint = 0;
      } else {
        if (this.restPrice == this.totalUseAmount) {
          return;
        } else if (this.restPrice - this.totalUseAmount < this.chargeCards[index].restPoint) {
          this.chargeCards[index].usePoint = this.restPrice - this.totalUseAmount;
        } else {
          this.chargeCards[index].usePoint = this.chargeCards[index].restPoint;
        }
        this.totalUseAmount += this.chargeCards[index].usePoint;
      }
      this.chargeCards[index].selected = !this.chargeCards[index].selected;
    },
    applyChargeCard(): void {
      this.setChargeCardTotalUseAmount(this.totalUseAmount);
      this.setSelectedChargeCardList(this.chargeCards);
      router.go(-1);
    },
    clearChargeCard(): void {
      this.clearSelectedChargeCardList();
      router.go(-1);
    }
  },
});
